import {useCallback,memo,useEffect} from 'react'

//styles
import 'devextreme/dist/css/dx.light.css';
import '../../styles/input/custom-input.css'

//components
import TagBox from "devextreme-react/tag-box";

import {
    Validator,
    RequiredRule,
  } from 'devextreme-react/validator';

const CustomTagbox = ({label, value, setValue,requiredValue,labelSize,isDisabled,values}) => {
  const onChangeValue = useCallback((data) => {
      setValue(data.value)
  }, []);
  
  return (
    <div className='custom-input' style={labelSize ? {gridTemplateColumns: `${labelSize} calc(100% - ${labelSize} - 20px)`} : {}}>
        <div className='custom-input__label'>{label}:{requiredValue ? <span>*</span> : ''}</div>
        <TagBox
          dataSource={values}
          value={value}
          disabled={isDisabled}
          onValueChanged={onChangeValue}
          hideSelectedItems={true}
          valueExpr="id"        
          displayExpr="name"
        >
            <Validator>
              {requiredValue && <RequiredRule message={`${label} is required`} />}
            </Validator>
        </TagBox>
    </div>
  )
}

export default memo(CustomTagbox)